import BaseApi from './baseApi';
import IOutboundDeliveryNotes from '../models/IOutboundDeliveryNotes';
import IAuthentication from '../models/IAuthentication';
export default class OutboundDeliveryNotesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Outbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundDeliveryNotes(idOutbound: string) : Promise<IOutboundDeliveryNotes[]> {
        let json : string = this.getJsonRead(idOutbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundDeliveryNotes: IOutboundDeliveryNotes[] = [];
            outboundDeliveryNotes = response.data as IOutboundDeliveryNotes[];
            return outboundDeliveryNotes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetOutboundDeliveryNotesShared(idCompany: string, idStatus: string | null) {
        let json : string = this.getJsonReadShared(idCompany, idStatus);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundDeliveryNotes: IOutboundDeliveryNotes[] = [];
            outboundDeliveryNotes = response.data as IOutboundDeliveryNotes[];
            return outboundDeliveryNotes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundDeliveryNotes(outboundDeliveryNotes: IOutboundDeliveryNotes) : Promise<string> {
        const json = this.getJsonSave(outboundDeliveryNotes);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundDeliveryNotes(outboundDeliveryNotes: IOutboundDeliveryNotes) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundDeliveryNotes);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotes(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDeliveryNotesByOutboundId(OutboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundId(OutboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByOutboundId(OutboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotes",
            "conditions": [{
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": OutboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotes",
            "conditions": [{
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(outboundDeliveryNotes: IOutboundDeliveryNotes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutbound",
                "Item2": outboundDeliveryNotes.idOutbound
            }, {
                "Item1": "idCompanySource",
                "Item2": outboundDeliveryNotes.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": outboundDeliveryNotes.idCompanyDestination
            }, {
                "Item1": "idWarehouse",
                "Item2": outboundDeliveryNotes.idWarehouse
            }, {
                "Item1": "idCustomer",
                "Item2": outboundDeliveryNotes.idCustomer
            }, {
                "Item1": "code",
                "Item2": outboundDeliveryNotes.code
            }, {
                "Item1": "dateOut",
                "Item2": outboundDeliveryNotes.dateOut
            }, {
                "Item1": "description",
                "Item2": outboundDeliveryNotes.description
            }, {
                "Item1": "idStatus",
                "Item2": outboundDeliveryNotes.idStatus
            }, {
                "Item1": "idDock",
                "Item2": outboundDeliveryNotes.idDock
            }, {
                "Item1": "dockPicked",
                "Item2": outboundDeliveryNotes.dockPicked
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotes"
        };
        return json;
    }

    private getJsonUpdate(outboundDeliveryNotes: IOutboundDeliveryNotes) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutbound",
                "Item2": outboundDeliveryNotes.idOutbound
            }, {
                "Item1": "idCompanySource",
                "Item2": outboundDeliveryNotes.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": outboundDeliveryNotes.idCompanyDestination
            }, {
                "Item1": "idWarehouse",
                "Item2": outboundDeliveryNotes.idWarehouse
            }, {
                "Item1": "idCustomer",
                "Item2": outboundDeliveryNotes.idCustomer
            }, {
                "Item1": "code",
                "Item2": outboundDeliveryNotes.code
            }, {
                "Item1": "dateOut",
                "Item2": outboundDeliveryNotes.dateOut
            }, {
                "Item1": "idStatus",
                "Item2": outboundDeliveryNotes.idStatus
            }, {
                "Item1": "description",
                "Item2": outboundDeliveryNotes.description
            }, {
                "Item1": "idDock",
                "Item2": outboundDeliveryNotes.idDock
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDeliveryNotes",
            "keyvalue": outboundDeliveryNotes.id
        };
        return json;
    }

    private getJsonReadShared(idCompany: string, idStatus: string | null) : any {
        const json = {
            "fields": [{
                "Item1": "",
                "Item2": "*"
            }],
            "tables": [{
                "Item1": "GetDelegatedOutboundsDeliveryNotes('" + idCompany + "', '" + idStatus + "')"
            }]
        };
        return json;
    }
 
    private getJsonRead(idOutbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "id"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idOutbound"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = OutboundsDeliveryNotes.IdCompanySource) as companySourceName"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = OutboundsDeliveryNotes.IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select Name from Warehouses where id = IdWarehouse) as warehouseName"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idCustomer"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = OutboundsDeliveryNotes.IdCustomer) as customerName"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "code"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "dateOut"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "description"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idStatus"
            }, {
                "Item1": "ListStatusOutboundsDeliveryNotes",
                "Item2": "name as statusName"
            }, {
                "Item1": "Outbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Outbounds",
                "Item2": "code as codeSource"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idDock"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListDocks where id = OutboundsDeliveryNotes.IdDock) as dockName"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "dockPicked"
            }],
            "tables": [{
                "Item1": "OutboundsDeliveryNotes"
            }, {
                "Item1": "ListStatusOutboundsDeliveryNotes"
            }, {
                "Item1": "Outbounds"
            }],
            "joins": [{
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idStatus",
                "Item3": "ListStatusOutboundsDeliveryNotes",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "idOutbound",
                "Item3": "Outbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsDeliveryNotes",
                "Item2": "IdOutbound",
                "Item3": "=",
                "Item4": idOutbound
            }]
        };
        return json;
    }
}
